'use strict';
/* eslint-disable react/jsx-handler-names */

/* THIS IS A SHARED COMPONENT. IT IS USED IN BOTH THE ADMIN AND WIDGET */

'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _Conversation = require('conversations-schema/records/Conversation');

var _Conversation2 = _interopRequireDefault(_Conversation);

var _Visitor = require('conversations-core/data/records/Visitor');

var _Visitor2 = _interopRequireDefault(_Visitor);

var _ColoringRecord = require('conversations-schema/records/ColoringRecord');

var _ColoringRecord2 = _interopRequireDefault(_ColoringRecord);

var _EmailCapture = require('conversations-core/components/input/EmailCapture');

var _EmailCapture2 = _interopRequireDefault(_EmailCapture);

var _FadeSlideTransition = require('conversations-core/components/transition/FadeSlideTransition');

var _FadeSlideTransition2 = _interopRequireDefault(_FadeSlideTransition);

var _RequestStatusTypes = require('conversations-schema/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

var _ConversationHistory = require('ui-addon-conversations/components/ConversationHistory');

var _ConversationHistory2 = _interopRequireDefault(_ConversationHistory);

var _TypingIndicator = require('ui-addon-conversations/components/TypingIndicator');

var _TypingIndicator2 = _interopRequireDefault(_TypingIndicator);

var _VisitorTimeoutLabel = require('ui-addon-conversations/components/labels/VisitorTimeoutLabel');

var _VisitorTimeoutLabel2 = _interopRequireDefault(_VisitorTimeoutLabel);

var _mobile = require('conversations-core/utils/mobile');

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

var _InfiniteScroll = require('conversations-core/components/InfiniteScroll');

var _InfiniteScroll2 = _interopRequireDefault(_InfiniteScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChatFeed = _react2.default.createClass({
  displayName: 'ChatFeed',

  propTypes: {
    currentRole: _react.PropTypes.oneOf(Object.keys(_RoleTypes2.default)).isRequired,
    currentChannel: _react.PropTypes.string,
    fetchNextHistory: _react.PropTypes.func,
    republishMessage: _react.PropTypes.func,
    coloring: _react.PropTypes.instanceOf(_ColoringRecord2.default),
    currentConversation: _react.PropTypes.instanceOf(_Conversation2.default),
    sendVisitorEmailAddress: _react.PropTypes.func,
    chatHistoryFetchStatus: _react.PropTypes.oneOf(Object.keys(_RequestStatusTypes2.default)),
    responderName: _react.PropTypes.string,
    currentVisitor: _react.PropTypes.instanceOf(_Visitor2.default),
    hasVisitorEmail: _react.PropTypes.bool,
    preview: _react.PropTypes.bool,
    isOnlineMode: _react.PropTypes.bool.isRequired,
    showTypingIndicator: _react.PropTypes.bool,
    isRecipientTimedout: _react.PropTypes.bool,
    showEmailCapture: _react.PropTypes.bool,
    emailCaptureMessageIndex: _react.PropTypes.number,
    emailCaptureMessage: _react.PropTypes.string,
    isAgentReady: _react.PropTypes.bool,
    publishMessage: _react.PropTypes.func,
    responders: _react.PropTypes.instanceOf(_immutable.Map).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      isOnlineMode: true
    };
  },
  componentDidMount: function componentDidMount() {
    var history = this.props.currentConversation.chatHistory.history;


    if (history && history.size !== 0) {
      this.refs.scrollingChatHistory.scrollContainerToBottom();
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var _props = this.props,
        chatHistory = _props.currentConversation.chatHistory,
        showTypingIndicator = _props.showTypingIndicator,
        emailCaptureMessageIndex = _props.emailCaptureMessageIndex;
    var prevChatHistory = prevProps.currentConversation.chatHistory,
        prevShowIndicator = prevProps.showTypingIndicator,
        prevEmailCaptureMessageIndex = prevProps.emailCaptureMessageIndex;


    if (!chatHistory) {
      return;
    }

    var chatHistoryUpdated = !prevChatHistory && chatHistory || !(0, _immutable.is)(chatHistory.history.filter(_ConversationalMessageModel.isConversationalMessage).last(), prevChatHistory.history.filter(_ConversationalMessageModel.isConversationalMessage).last());

    var emailCaptureUpdated = emailCaptureMessageIndex !== prevEmailCaptureMessageIndex;
    var typingIndicatorUpdated = showTypingIndicator !== prevShowIndicator;

    // prevents scrolling to the bottom on every time
    // the component updates and `isRecipientTimedout === true`
    var isRecipientTimedout = this.props.isRecipientTimedout && !prevProps.isRecipientTimedout;

    if (chatHistoryUpdated || emailCaptureUpdated || typingIndicatorUpdated || isRecipientTimedout) {
      this.refs.scrollingChatHistory.scrollContainerToBottom();
    }
  },
  fetchHistoryWithProps: function fetchHistoryWithProps(props) {
    var isOnlineMode = props.isOnlineMode,
        currentChannel = props.currentChannel,
        fetchNextHistory = props.fetchNextHistory,
        preview = props.preview,
        currentConversation = props.currentConversation;


    if (preview || !isOnlineMode || !fetchNextHistory) {
      return;
    }

    var chatHistory = currentConversation.chatHistory;
    var latestStartTime = chatHistory.startTime;

    fetchNextHistory(currentChannel, latestStartTime);
  },
  hasMoreHistory: function hasMoreHistory() {
    var chatHistory = this.props.currentConversation.chatHistory;


    if (!chatHistory) {
      return false;
    }

    var hasHistory = chatHistory.history.size > 0;
    var latestIsStart = chatHistory.startTime === chatHistory.endTime;

    return hasHistory && !latestIsStart;
  },
  fetchMore: function fetchMore() {
    if (this.hasMoreHistory()) {
      this.fetchHistoryWithProps(this.props);
    }
  },
  renderTypingIndicator: function renderTypingIndicator() {
    var _props2 = this.props,
        showTypingIndicator = _props2.showTypingIndicator,
        currentRole = _props2.currentRole,
        coloring = _props2.coloring;


    var otherRole = currentRole === _RoleTypes2.default.REP ? _RoleTypes2.default.VISITOR : _RoleTypes2.default.REP;

    if (!showTypingIndicator) {
      return null;
    }

    return _react2.default.createElement(_TypingIndicator2.default, {
      currentRole: currentRole,
      messageRole: otherRole,
      coloring: coloring
    });
  },
  renderRecipientTimedout: function renderRecipientTimedout() {
    var _props3 = this.props,
        isRecipientTimedout = _props3.isRecipientTimedout,
        currentRole = _props3.currentRole,
        currentVisitor = _props3.currentVisitor;


    if (currentRole !== _RoleTypes2.default.REP || !isRecipientTimedout) {
      return null;
    }

    var visitorName = _I18n2.default.text('chat.thisVisitor');
    if (currentVisitor && currentVisitor.firstName) {
      visitorName = currentVisitor.firstName;
    }

    return _react2.default.createElement(_VisitorTimeoutLabel2.default, { visitorName: visitorName });
  },
  renderMessage: function renderMessage(messageElement, message, index) {
    var _props4 = this.props,
        showEmailCapture = _props4.showEmailCapture,
        emailCaptureMessageIndex = _props4.emailCaptureMessageIndex;


    if (showEmailCapture && index === emailCaptureMessageIndex) {
      return [messageElement, this.renderEmailCapture()];
    }

    return messageElement;
  },
  renderFeed: function renderFeed() {
    var _props5 = this.props,
        chatHistory = _props5.currentConversation.chatHistory,
        currentRole = _props5.currentRole,
        coloring = _props5.coloring,
        republishMessage = _props5.republishMessage,
        publishMessage = _props5.publishMessage,
        responders = _props5.responders;


    return _react2.default.createElement(
      _ConversationHistory2.default,
      {
        chatHistory: chatHistory,
        responders: responders,
        currentRole: currentRole,
        coloring: coloring,
        renderMessage: this.renderMessage,
        publishMessage: publishMessage,
        republishMessage: republishMessage
      },
      this.renderTypingIndicator(),
      this.renderRecipientTimedout()
    );
  },
  renderEmailCapture: function renderEmailCapture() {
    var _props6 = this.props,
        coloring = _props6.coloring,
        responderName = _props6.responderName,
        hasVisitorEmail = _props6.hasVisitorEmail,
        emailCaptureMessage = _props6.emailCaptureMessage,
        currentRole = _props6.currentRole,
        isOnlineMode = _props6.isOnlineMode,
        isAgentReady = _props6.isAgentReady,
        sendVisitorEmailAddress = _props6.sendVisitorEmailAddress;


    return _react2.default.createElement(
      'div',
      { className: 'm-top-3 m-bottom-5', key: 'email-capture-container' },
      _react2.default.createElement(_EmailCapture2.default, {
        online: isOnlineMode,
        coloring: coloring,
        responderName: responderName,
        hasVisitorEmail: hasVisitorEmail,
        emailCaptureMessage: emailCaptureMessage,
        currentRole: currentRole,
        isAgentReady: isAgentReady,
        onSubmit: sendVisitorEmailAddress
      })
    );
  },
  render: function render() {
    var currentRole = this.props.currentRole;


    var className = (0, _reactUtils.classNames)('messages-container flex-column add-flex-grow', {
      'p-x-10': currentRole === _RoleTypes2.default.REP,
      'p-x-6': currentRole !== _RoleTypes2.default.REP,
      'chat-feed-bottom': (0, _mobile.isIOS)()
    });

    return _react2.default.createElement(
      _InfiniteScroll2.default,
      { fetchMore: this.fetchMore, ref: 'scrollingChatHistory' },
      _react2.default.createElement(
        _FadeSlideTransition2.default,
        {
          className: className,
          appear: true,
          leave: false,
          direction: 'top'
        },
        this.renderFeed()
      )
    );
  }
});

exports.default = ChatFeed;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/components/chat/ChatFeed.js
// module id = 273
// module chunks = 0 1